import { Button } from '@cube3/cubicle/src/core/atoms/Button';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

const DIMENSIONS = { width: 48, height: 48 } as const;

export const ImageDropzone = ({ onDrop, onDelete, images }) => {
  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true,
    accept: { 'image/*': [] },
    useFsAccessApi: false //doesn't work with playwright testing
  });

  return (
    <div
      {...getRootProps({
        style: {
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }
      })}
    >
      {images.length
        ? images.map((img) => (
            <ImageBox
              key={img.src}
              dimensions={DIMENSIONS}
              src={img.src}
              onDelete={() => onDelete(img)}
            />
          ))
        : null}
      <input {...getInputProps()} />
      <Button
        iconLeft="image"
        onClick={open}
        buttonStyle="dashed"
        size={SizeVariants.lg}
      />
    </div>
  );
};

const ImageBox = (props) => {
  const { src, dimensions, onDelete } = props;
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div style={{ ...dimensions, position: 'relative' }}>
      <div
        style={{
          position: 'absolute',
          zIndex: 2,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: isHovering ? 'rgba(0,0,0,0.64)' : 'transparent' // theme.color.black['64']
        }}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        {isHovering && (
          <Button iconLeft="delete" size={SizeVariants.lg} onClick={onDelete} />
        )}
      </div>
      <img
        src={src}
        alt="image"
        style={{ ...dimensions, borderRadius: 8, objectFit: 'cover' }}
      />
    </div>
  );
};
